import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageTitle, PageActions, PageSubtitle } from "../Layouts/components/PageTitleContainer";
import { LocationTypeMovementBlock } from "types/locationManagement/locationTypeMovementBlock";
import { RevivnDatabaseDataGrid } from "components/DataGrid/RevivnDatabaseDataGrid";
import { linkColDef } from "components/DataGrid/columnDefs/linkColDef";
import { actionColDef } from "components/DataGrid/columnDefs/actionColDef";
import { GridValueGetterParams } from "@mui/x-data-grid-pro";

const LocationTypeMovementBlockList: React.FC = () => {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs
        links={[{ label: "Admin" }, { label: "Location Type Movement Blocks", path: "/location-type-movement-blocks" }]}
      />
      <PageTitle>Movement Rules</PageTitle>
      <PageSubtitle>
        Control how inventory moves between locations. By default, inventory can move freely — use rules to block
        invalid moves between specific location types. Ex: Inventory cannot move from TECH to SORT.
      </PageSubtitle>
      <PageActions>
        <Button variant="contained" color="primary" component={Link} to="/location-type-movement-blocks/new">
          Create Movement Block
        </Button>
      </PageActions>
      <RevivnDatabaseDataGrid
        url="/location_management/location_type_movement_blocks"
        syncStateWithSearchParams
        columns={[
          { field: "id", headerName: "ID", width: 90, filterable: false },
          {
            field: "fromLocationType.name",
            headerName: "From Location Type",
            width: 200,
            filterable: false,
            valueGetter: (params: GridValueGetterParams) => params.row.fromLocationType?.name || "Any Location Type",
            ...linkColDef<LocationTypeMovementBlock>(({ row }) => `/location-types/${row.fromLocationType.id}/edit`),
          },
          {
            field: "toLocationType.name",
            headerName: "To Location Type",
            width: 200,
            filterable: false,
            valueGetter: (params: GridValueGetterParams) => params.row.toLocationType?.name || "Any Location Type",
            ...linkColDef<LocationTypeMovementBlock>(({ row }) => `/location-types/${row.toLocationType.id}/edit`),
          },
          {
            field: "description",
            headerName: "Description",
            width: 200,
            filterable: false,
          },
          {
            field: "edit",
            headerName: "Edit",
            width: 120,
            sortable: false,
            filterable: false,
            valueGetter: (_params: GridValueGetterParams) => "Edit",
            ...linkColDef<LocationTypeMovementBlock>(({ row }) => `/location-type-movement-blocks/${row.id}/edit`),
          },
          {
            field: "delete",
            headerName: "Delete",
            width: 120,
            sortable: false,
            filterable: false,
            ...actionColDef<LocationTypeMovementBlock>(
              ({ row }) => ({ method: "delete", action: `/location-type-movement-blocks/${row.id}/delete` }),
              <Button
                type="submit"
                variant="outlined"
                color="error"
                size="small"
                onClick={(e) => {
                  if (!confirm("Are you sure you want to delete this movement block?")) {
                    e.preventDefault();
                  }
                }}
              >
                Delete
              </Button>,
            ),
          },
        ]}
        pageSize={25}
      />
    </FullPagePaperLayout>
  );
};

export default LocationTypeMovementBlockList;
